import type { AuthChangeEvent, Session } from '@supabase/supabase-js'

import getClient from './getClient'

export default function onAuthStateChange(
  callback: (event: AuthChangeEvent, session: Session | null) => void,
) {
  return getClient().auth.onAuthStateChange(callback)
}
